const app = angular.module('msi.payments', [
  require('@ordergroove/brandy/src/app/spinner'),
  require('./modal'),
  require('./payment.service'),
  require('./form'),
  require('./expiration-warning')
]);

app.component('ogBilling', require('./billing/billing'));

module.exports = app.name;
